import groq from "groq";

const previewBySlug = groq`
*[( slug.current == $slug || handle == $slug )] {
  'slug': slug.current,
  handle,
}[0]
`;

export default previewBySlug;
